import Box from "@mui/material/Box";
import GlobalStyles from "@mui/material/GlobalStyles";
import * as React from "react";

import { Footer } from "./footer";
import { MainNav } from "./main-nav";

interface LayoutProps {
	children: React.ReactNode;
	topBanner?: React.ReactNode;
	hideAuthActions?: boolean;
}

export function Layout({ children, topBanner, hideAuthActions }: LayoutProps) {
	return (
		<React.Fragment>
			<GlobalStyles
				styles={{
					body: {
						"--MainNav-height": "72px",
						"--MainNav-zIndex": 1000,
						"--SideNav-width": "280px",
						"--SideNav-zIndex": 1100,
						"--MobileNav-width": "320px",
						"--MobileNav-zIndex": 1100,
					},
				}}
			/>
			<div>
				<Box
					component="header"
					sx={{
						left: 0,
						position: "sticky",
						right: 0,
						top: 0,
						zIndex: "var(--MainNav-zIndex)",
					}}>
					{topBanner}
					<MainNav hideAuthActions={hideAuthActions} />
				</Box>
				{children}
				<Footer />
			</div>
		</React.Fragment>
	);
}
